import { GameLanguageCode, PrizeMode, PrizeType } from "../types";

export const GAME_LANGUAGES: { code: GameLanguageCode; label: string }[] = [
    { code: "zh-TW", label: "繁體中文" },
    { code: "zh-CN", label: "簡體中文" },
    { code: "en-US", label: "英文" },
    { code: "ja-JP", label: "日文" },
    { code: "ko-KR", label: "韓文" },
];
export const GAME_TIME_RANGE = { min: 20, max: 60, step: 5, default: 30 };
export const PUZZLE_COUNT_RANGE = { min: 2, max: 5, step: 1, default: 3 };
export const PAIR_COUNT_RANGE = { min: 2, max: 5, step: 1, default: 3 };
export const QUIZ_TOTAL_RANGE = { min: 2, max: 10, step: 1, default: 5 };
export const QUIZ_PASS_RANGE = { min: 2, max: 10, step: 1, default: 3 };
export const AUTO_START_COUNTDOWN_RANGE = { min: 5, max: 30, step: 5, default: 10 };

// ========= Content Limits ============
export const MAX_GAME_ITEMS = 10;
export const MAX_PUZZLE_ITEMS = 5;
export const MAX_QUIZ_OPTIONS = 4;

// ========= File Upload ============
export const GAME_BGM_ACCEPT = "mp3";
export const GAME_BG_ACCEPT = ["jpg", "jpeg", "png"];
export const GAME_IMAGE_ACCEPT = ["jpg", "jpeg", "png"];
export const GAME_BGM_SIZE_LIMIT = 80 * 1024 * 1024; // 80MB
export const GAME_BG_SIZE_LIMIT = 20 * 1024 * 1024; // 20MB
export const GAME_IMAGE_SIZE_LIMIT = 20 * 1024 * 1024; // 20MB

// ========= Tab configuration ============
export const GAME_TAB_IDS = {
    GENERAL: "general",
    PUZZLE: "puzzle",
    QUIZ: "quiz",
    FLIPCARD: "flipcard",
    PRIZE: "prize",
};

export type GameTabId = (typeof GAME_TAB_IDS)[keyof typeof GAME_TAB_IDS];

export const GAME_TABS: { id: GameTabId; labelKey: string }[] = [
    { id: GAME_TAB_IDS.GENERAL, labelKey: "APPWIDGET.GAME_GENERAL" },
    { id: GAME_TAB_IDS.PUZZLE, labelKey: "APPWIDGET.GAME_PUZZLE" },
    { id: GAME_TAB_IDS.QUIZ, labelKey: "APPWIDGET.GAME_QUIZ" },
    { id: GAME_TAB_IDS.FLIPCARD, labelKey: "APPWIDGET.GAME_FLIPCARD" },
    { id: GAME_TAB_IDS.PRIZE, labelKey: "APPWIDGET.GAME_PRIZE" },
];

// ========= Prize Mode Options ============
export const PRIZE_MODE_OPTIONS: { value: PrizeMode; labelKey: string }[] = [
    { value: "wheel", labelKey: "APPWIDGET.GAME_PRIZE_MODE_WHEEL" },
    { value: "slot", labelKey: "APPWIDGET.GAME_PRIZE_MODE_SLOT" },
];

// ========= Prize Type Options ============
export const PRIZE_TYPE_OPTIONS: { value: PrizeType; labelKey: string }[] = [
    { value: "none", labelKey: "APPWIDGET.GAME_PRIZE_TYPE_NONE" },
    { value: "qrcode", labelKey: "APPWIDGET.GAME_PRIZE_TYPE_QRCODE" },
    { value: "image", labelKey: "APPWIDGET.GAME_PRIZE_TYPE_IMAGE" },
];
